/* ============================================================================
   Move STOQ's "Notify me when available" button into the buy box.

   STOQ renders it as a vertical tab fixed to the right edge of the window
   (`.restock-rocket-button-container-float-right`, rotated -90deg). Shoppers do
   not see it — and on a deliberate sell-out, joining the waitlist is the only
   action we want, so it has to sit directly under the Sold out button.

   The app has an inline mode, but switching to it needs a click inside the STOQ
   admin iframe, which does not accept automated clicks. Adding STOQ's own
   `#restock-rocket-inline-container` without that setting is worse than doing
   nothing: it suppresses the floating tab and renders nothing into the
   container, so there is no button anywhere. Moving the live node sidesteps the
   app's configuration entirely and keeps its click handler intact.
   ========================================================================== */

(function () {
  'use strict';

  var SLOT  = '[data-restock-slot]';
  var FLOAT = '.restock-rocket-button-container-float-right';

  function place() {
    var slot = document.querySelector(SLOT);
    if (!slot) return false;

    var box = document.querySelector(FLOAT);
    if (!box) {
      /* back in stock: STOQ removes its button, so the slot must collapse too */
      slot.classList.remove('is-filled');
      return false;
    }
    if (box.parentElement !== slot) slot.appendChild(box);
    slot.classList.add('is-filled');
    return true;
  }

  /* STOQ injects a while after DOMContentLoaded, so poll briefly... */
  var tries = 0;
  var poll = window.setInterval(function () {
    if (place() || ++tries > 60) window.clearInterval(poll);
  }, 250);

  /* ...and keep watching, because it re-renders the button when the shopper
     changes variant, which would otherwise put a fresh one back on the edge.
     place() is a no-op once the node is already in the slot, so the observer
     cannot loop on its own mutations. */
  if (window.MutationObserver) {
    new MutationObserver(function () { place(); })
      .observe(document.body, { childList: true, subtree: true });
  }
})();
